import styled from 'styled-components'

import { BaseBadgeStyles, type IBaseBadgeProps } from './BaseBadgeStyles'
import { type InfoBadgeType } from '../InfoBadge'

interface IInfoBadgeStyledProps extends IBaseBadgeProps {
  type: InfoBadgeType
}

export const InfoBadgeStyled = styled.span<IInfoBadgeStyledProps>`
  ${BaseBadgeStyles}

  color: ${(props) => props.theme.colors.badge[props.type].content};

  background: ${(props) => props.theme.colors.badge[props.type].background};
`
